export enum EmployeeAssignmentState {
  NoAssignment = 'NoAssignment',
  MultiplePrimaryAssignments = 'MultiplePrimaryAssignments',
  OnlySecondaryAssignments = 'OnlySecondaryAssignments'
}
